// HOOKS
import { useLazyQuery } from "@apollo/client";
import useQuery from "../other/useQuery.other.hook";
import { useState, useEffect } from "react";
// GRAPHQL
import { GET_PRODUCTS } from "../../graphql/queries/products/products.queries";
import convertToyyyyMMdd from "../../utils/conversions/dates/yyyyMMdd.date.conversion.util";

const DEFAULT_QUERY = {
  search: "",
  page: 1,
  limit: 25,
  sort: "-updated_at",
};

const useGetManyProducts = () => {
  const [products, setProducts] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [productInput, setProductInput] = useState({});
  const [getProductQuery, { loading, error, data }] = useLazyQuery(
    GET_PRODUCTS,
    {
      fetchPolicy: "no-cache",
    }
  );
  const {
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
  } = useQuery({ defaultQuery: DEFAULT_QUERY });

  const getProducts = async () => {
    try {
      const res = await getProductQuery({
        variables: { query, product: productInput },
      });
      if (res?.data?.products?.products)
        setProducts(
          res.data.products.products.map((product) => ({
            ...product,
            // Add any date fields or other fields that need to be converted here
            tags: product.tags.join(", "),
          }))
        );
      if (res?.data?.products?.metaData)
        setMetaData(res.data.products.metaData);
    } catch (error) {
      console.error(`Error getting product: ${error?.message}`);
      alert(`Error getting product: ${error?.message}`);
    }
  };

  // Get products on query or productInput change
  useEffect(() => {
    getProducts();
  }, [query, productInput]);

  return {
    getProducts,
    products,
    setProducts,
    metaData,
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading,
    error,
  };
};

export default useGetManyProducts;
